// Core result images are editorial context, never product or availability evidence.
// Shared by the result registry and the offline build manifest.
export const resultEditorialPaths={
 object:'/art/gift-object.webp',
 experience:'/art/gift-experience.webp',
 choice:'/art/gift-choice.webp',
 gesture:'/art/gift-gesture.webp',
} as const;
